module.exports = __webpack_public_path__ + "images/emoji/evergreen_tree.12830dce61b1e83d3fe1.png";